<template>
  <DeleteModal :item-id="cellData" :item-name="entityName" :delete-fn="confirmFn" />
</template>

<script>
import ToastService from '/@/modules/core/ui/services/ToastService';
import { ModalMixin } from '/@/modules/core/ui/mixins/ModalMixin';
import { ModalCypressAttribute } from '/@/modules/core/app/constants/ModalCypressAttribute';
import { CellMixin } from '/@/modules/core/table/mixins/CellMixin';
import { BaseListService } from '/@/modules/core/table/services/BaseListService';
import DeleteModal from '/@/modules/core/app/components/DeleteModal.vue';
import { TableReloadMixin } from '@/modules/core/table/mixins/TableReloadMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DeleteCellModal',
  mixins: [CellMixin, ModalMixin, TableReloadMixin],
  components: {
    DeleteModal
  },
  props: {
    deleteFn: {
      type: Function,
      default: undefined
    },
    dataService: {
      type: BaseListService,
      required: true
    },
    tableId: {
      type: String
    },
    primaryKeyField: {
      type: String
    },
    primaryNameField: {
      type: String
    },
    deleteSuccessText: {
      type: String,
      required: false
    },
    customEntityName: {
      type: String
    }
  },
  static: {
    ModalCypressAttribute
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    confirmFn() {
      const itemId = this.cellData;

      this.isLoading = true;
      this.deleteStartRow(this.rowData);

      this.dataService
        .deleteRow(itemId)
        .then(() => {
          ToastService.show(
            this.deleteSuccessText || `<b>${this.entityName || ''}</b> successfully deleted.`
          );
          this.deleteRow(this.rowData);
        })
        .catch((e) => {
          ToastService.show(e.message);
          this.restoreFailedRow(this.rowData);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  created() {
    this.entityName = this.customEntityName ?? this.rowData[this.primaryNameField];
  }
};
</script>
